import type { SVGComponentProps } from 'BreetHelpers';

export const WalletDefaultIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='60'
		height='24'
		viewBox='0 0 60 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<rect
			width='60'
			height='24'
			rx='12'
			fill='#FFF1FF'
		/>
		<circle
			cx='10'
			cy='12'
			r='3'
			fill='#C353A4'
		/>
		<path
			d='M21.6831 8.7C23.7831 8.7 25.2731 10.09 25.2731 12.05C25.2731 14.07 23.7831 15.5 21.6831 15.5H19.2931V8.7H21.6831ZM21.6831 14.77C23.3031 14.77 24.4631 13.64 24.4631 12.05C24.4631 10.53 23.3031 9.43 21.6831 9.43H20.0831V14.77H21.6831ZM28.2961 10.74C29.7861 10.74 30.7161 11.89 30.5661 13.41H26.6861C26.7761 14.27 27.3661 14.94 28.3361 14.94C28.9261 14.94 29.3761 14.73 29.5761 14.34H30.4261C30.1361 15.14 29.3361 15.62 28.3361 15.62C26.9061 15.62 25.9161 14.55 25.9161 13.18C25.9161 11.81 26.8961 10.74 28.2961 10.74ZM28.2961 11.4C27.3761 11.4 26.8061 12.05 26.6961 12.87H29.8061C29.7661 11.95 29.1761 11.4 28.2961 11.4ZM32.7697 10.03V10.86H34.6297V11.51H32.7697V15.5H32.0097V11.51H30.6597V10.86H32.0097V10.03C32.0097 8.95 32.7297 8.28 33.7497 8.28C34.0197 8.28 34.3297 8.32 34.6697 8.42L34.5597 9.06C34.3097 8.99 34.0197 8.94 33.8297 8.94C33.1797 8.94 32.7697 9.37 32.7697 10.03ZM38.6771 10.86H39.4371V15.5H38.6771V15.02C38.2671 15.4 37.7071 15.62 37.0471 15.62C35.7171 15.62 34.6571 14.54 34.6571 13.18C34.6571 11.83 35.7171 10.74 37.0471 10.74C37.7071 10.74 38.2671 10.96 38.6771 11.34V10.86ZM37.1471 14.92C37.7571 14.92 38.2971 14.69 38.6771 14.13V12.23C38.2971 11.67 37.7571 11.44 37.1471 11.44C36.1671 11.44 35.4171 12.22 35.4171 13.18C35.4171 14.14 36.1671 14.92 37.1471 14.92ZM44.1388 10.86H44.8988V15.5H44.1388V14.97C43.7088 15.38 43.1388 15.62 42.4788 15.62C41.2988 15.62 40.4888 14.81 40.4888 13.5V10.86H41.2488V13.46C41.2488 14.4 41.7988 14.92 42.6188 14.92C43.1688 14.92 43.7388 14.63 44.1388 14.1V10.86ZM46.1382 8.4H46.8982V15.5H46.1382V8.4ZM51.1107 14.75L51.2207 15.45C50.8407 15.58 50.5207 15.62 50.2407 15.62C49.1007 15.62 48.5507 14.99 48.5507 13.78V11.51H47.3407V10.86H48.5507V9.15H49.3107V10.86H51.0607V11.51H49.3107V13.78C49.3107 14.58 49.6507 14.91 50.3107 14.91C50.5707 14.91 50.8607 14.84 51.1107 14.75Z'
			fill='#970F71'
		/>
	</svg>
);
